<template>
  <article>
    <!--详情栏-->
    <div class="flex flex-wrap aic">
      <div class="form-item">ID:</div>
      <el-input size="small" style="width: 300px" placeholder="" v-model="detail.id" :disabled="true"></el-input>
    </div>
    <div class="flex flex-wrap aic mt-20">
      <div class="form-item">模块</div>
      <el-select v-model="detail.market" size="small">
        <el-option :value="0" label="无"></el-option>
        <el-option :value="1" label="贝贝家"></el-option>
        <el-option :value="2" label="电商"></el-option>
      </el-select>
    </div>
    <div class="flex flex-wrap aic mt-20">
      <div class="form-item">标题:</div>
      <el-input size="small" style="width: 300px" placeholder="" v-model="detail.title"></el-input>
    </div>
    <div class="flex flex-wrap aic mt-20">
          <div class="form-item">状态：</div>
          <el-radio-group v-model="detail.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
    </div>
    <!--绘画栏-->
    <div class="flex flex-wrap">
        <div class="">
          <div class="flex flex-wrap">
            <div class="flex aic mr-30 mt-20">
              <div class="form-item">背景图片</div>
              <div class="blue-small-btn relative">
                <div>图片上传</div>
                <uploadHeadImage :url.sync="detail.bg_url" :itype="5"></uploadHeadImage>
                <!--
                <uploadImage @readSuccess="uploadImg"></uploadImage>
                -->
              </div>
            </div>
            <div class="flex aic mt-20">
              <div class="form-item">测试文字</div>
              <el-input v-model="preview.words" placeholder="" size="small" style="width: 100px"></el-input>
            </div>

          </div>

          <div class="flex flex-wrap aic">
            <div class="form-item mt-20">用户名字</div>
            <div class="flex flex-wrap">
              <div class="flex aic mt-20 mr-14">
                <div>x</div>
                <el-input v-model="card.name.x" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">y</div>
                <el-input v-model="card.name.y" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">w</div>
                <el-input v-model="card.name.w" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">h</div>
                <el-input v-model="card.name.h" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">颜色(</div>
                <div class="">r</div>
                <el-input v-model="card.name.color.r" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">g</div>
                <el-input v-model="card.name.color.g" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">b</div>
                <el-input v-model="card.name.color.b" placeholder="" size="small" class="card-input ml-10"></el-input>
                <div class="">)</div>
              </div>
              <div class="flex aic mt-20">
                <div class="">大小</div>
                <el-input v-model="card.name.size" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap aic">
            <div class="form-item mt-20">用户余额</div>
            <div class="flex flex-wrap">
              <div class="flex aic mt-20 mr-14">
                <div>x</div>
                <el-input v-model="card.balance.x" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">y</div>
                <el-input v-model="card.balance.y" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">w</div>
                <el-input v-model="card.balance.w" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">h</div>
                <el-input v-model="card.balance.h" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">颜色(</div>
                <div class="">r</div>
                <el-input v-model="card.balance.color.r" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">g</div>
                <el-input v-model="card.balance.color.g" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">b</div>
                <el-input v-model="card.balance.color.b" placeholder="" size="small" class="card-input ml-10"></el-input>
                <div class="">)</div>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">大小</div>
                <el-input v-model="card.balance.size" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap aic">
            <div class="form-item mt-20">公众号二维码</div>
            <div class="flex flex-wrap">
              <div class="flex aic mt-20 mr-14">
                <div>x</div>
                <el-input v-model="card.qrcode.x" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">y</div>
                <el-input v-model="card.qrcode.y" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">w</div>
                <el-input v-model="card.qrcode.w" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">h</div>
                <el-input v-model="card.qrcode.h" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">颜色(</div>
                <div class="">r</div>
                <el-input v-model="card.qrcode.color.r" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">g</div>
                <el-input v-model="card.qrcode.color.g" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">b</div>
                <el-input v-model="card.qrcode.color.b" placeholder="" size="small" class="card-input ml-10"></el-input>
                <div class="">)</div>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">大小</div>
                <el-input v-model="card.qrcode.size" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap aic">
            <div class="form-item mt-20">用户头像</div>
            <div class="flex flex-wrap">
              <div class="flex aic mt-20 mr-14">
                <div>x</div>
                <el-input v-model="card.headimg.x" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">y</div>
                <el-input v-model="card.headimg.y" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">w</div>
                <el-input v-model="card.headimg.w" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">h</div>
                <el-input v-model="card.headimg.h" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">颜色(</div>
                <div class="">r</div>
                <el-input v-model="card.headimg.color.r" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">g</div>
                <el-input v-model="card.headimg.color.g" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">b</div>
                <el-input v-model="card.headimg.color.b" placeholder="" size="small" class="card-input ml-10"></el-input>
                <div class="">)</div>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">大小</div>
                <el-input v-model="card.headimg.size" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap aic">
            <div class="form-item mt-20">用户UNID</div>
            <div class="flex flex-wrap">
              <div class="flex aic mt-20 mr-14">
                <div>x</div>
                <el-input v-model="card.unid.x" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">y</div>
                <el-input v-model="card.unid.y" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">w</div>
                <el-input v-model="card.unid.w" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">h</div>
                <el-input v-model="card.unid.h" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">颜色(</div>
                <div class="">r</div>
                <el-input v-model="card.unid.color.r" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">g</div>
                <el-input v-model="card.unid.color.g" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">b</div>
                <el-input v-model="card.unid.color.b" placeholder="" size="small" class="card-input ml-10"></el-input>
                <div class="">)</div>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">大小</div>
                <el-input v-model="card.unid.size" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap">
            <div class="form-item mt-20">公众号名字</div>
            <div class="flex flex-wrap">
              <div class="flex aic mt-20 mr-14">
                <div>x</div>
                <el-input v-model="card.app_name.x" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">y</div>
                <el-input v-model="card.app_name.y" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">w</div>
                <el-input v-model="card.app_name.w" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">h</div>
                <el-input v-model="card.app_name.h" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">颜色(</div>
                <div class="">r</div>
                <el-input v-model="card.app_name.color.r" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-10">
                <div class="">g</div>
                <el-input v-model="card.app_name.color.g" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">b</div>
                <el-input v-model="card.app_name.color.b" placeholder="" size="small" class="card-input ml-10"></el-input>
                <div class="">)</div>
              </div>
              <div class="flex aic mt-20 mr-14">
                <div class="">大小</div>
                <el-input v-model="card.app_name.size" placeholder="" size="small" class="card-input ml-10"></el-input>
              </div>
            </div>
          </div>
          <div class="blue-large-btn" style="margin: 80px auto 0" @click="savePoster">保存</div>
          <div>注意:<br/> ①背景图的像素规格为640 × 1008<br/>②用户名字栏若x为非空，则x，y，r，g，b，大小，必须填有数字<br/>③用户余额栏若x为非空，则x，y，r，g，b，大小，必须填为数字<br/>④公众号二维码栏若x为非空，则x，y，w，h必须填为数字<br/>
            ⑤用户头像栏若x为非空，则x，y，w，h必须填有数字<br/>⑥用户unid栏若x为非空，则x，y，r，g，b，大小，必须填有数字<br/>⑦公众号名字栏若x为非空，则x，y，r，g，b，大小，必须填有数字<br/><br/>提示：<br/>①若不想在名片中显示某栏属性则只需将该栏x置为空即可<br/>②若想文字类水平居中，则只需在该栏x填入0即可。

          </div>
        </div>
        <!--<img :src="previewPoster" width="320" height="504" class="ml30 fl">-->
        <div class="">
          <canvas id="poster" class="db"></canvas>
        </div>

      </div>
  </article>
</template>

<style>
  .form-item{
    width: 80px;
  }
    pre{
    margin: 0;
  }
  .form-item{
    width: 100px;
    color: #2b2b2b;
  }
  .blue-small-btn{
    height: 27px;
    line-height: 27px;
    background-color: #0088ff;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    padding: 0 20px;
  }
  .card-input{
    width: 60px;
  }
  #poster{
    zoom: 0.5;
  }

  @media screen and (max-width: 768px) {
    .card-input{
      width: 50px;
    }
    #poster{
      margin: 0 auto;
    }
  }
</style>

<script>
//  import util from '../../../api/util'
import {getCardDetail, cardEdit, imageUpload} from '../../../api/api'
import uploadImage from '../../../components/uploadImage.vue'
import uploadHeadImage from '../../../components/uploadHeadImage.vue'
// import uploadImage from '../../../components/uploadImage.vue'
export default {
  components: {
    uploadImage,
    uploadHeadImage
  },
  data () {
    return {
      detail: {
        id: 0,
        market: 2,
        card: '',
        title: '',
        status: 1
      },
      preview: { // 测试文字
        words: '测试文字'
      },
      card: {
        bg_url: '',
        headimg: {
          x: '',
          y: '',
          w: '',
          h: '',
          color: {
            r: '',
            g: '',
            b: ''
          },
          size: ''
        },
        balance: {
          x: '',
          y: '',
          w: '',
          h: '',
          color: {
            r: '',
            g: '',
            b: ''
          },
          size: ''
        },
        qrcode: {
          x: '',
          y: '',
          w: '',
          h: '',
          color: {
            r: '',
            g: '',
            b: ''
          },
          size: ''
        },
        unid: {
          x: '',
          y: '',
          w: '',
          h: '',
          color: {
            r: '',
            g: '',
            b: ''
          },
          size: ''
        },
        name: {
          x: '',
          y: '',
          w: '',
          h: '',
          color: {
            r: '',
            g: '',
            b: ''
          },
          size: ''
        },
        app_name: {
          x: '',
          y: '',
          w: '',
          h: '',
          color: {
            r: '',
            g: '',
            b: ''
          },
          size: ''
        }
      }
    }
  },
  methods: {
    cardEdit () {
      let params = this.detail
      cardEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          if (params.id === 0) {
            this.$router.push('/cardList')
          }
        } else {
          this.$notify({
            title: '失败',
            message: '保存失败',
            type: 'error'
          })
        }
      }).catch(() => {
        this.$notify({
          title: '失败',
          message: '服务器大脑短路啦',
          type: 'error'
        })
      })
    },
    getCardDetail () {
      let params = {
        id: this.detail.id
      }
      console.log(this.detail.id)
      getCardDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d.card
          this.card = JSON.parse(this.detail.card)
        }
      })
    },
    uploadImg (base64) { // 上传图片
      let params = {
        icon: base64
      }
      imageUpload(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '上传成功',
            type: 'success'
          })
          this.card.bg_url = data.d.url
        } else {
          this.$notify({
            title: '失败',
            message: '上传失败',
            type: 'error'
          })
        }
      }).catch(() => {
        this.$notify({
          title: '失败',
          message: '服务器大脑短路啦',
          type: 'error'
        })
      })
    },
    // 错误提示
    notifyError (str) {
      this.$notify({
        title: '失败',
        message: str,
        type: 'error'
      })
    },

    // 成功提示
    notifySuccess (str) {
      this.$notify({
        title: '成功',
        message: str,
        type: 'success'
      })
    },
    makePoster () {
      let $this = this
      let card = $this.card
      let canvas = document.getElementById('poster')
      let ctx = canvas.getContext('2d')
      let bgImg = new Image()
      bgImg.src = $this.card.bg_url
      bgImg.onload = function () {
        canvas.width = bgImg.width
        canvas.height = bgImg.height

        ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height)

        $this.write(ctx, card.name, 1)
        $this.write(ctx, card.unid, 1)
        $this.write(ctx, card.app_name, 1)
        $this.write(ctx, card.balance, 1)
        $this.write(ctx, card.headimg, 2)
        $this.write(ctx, card.qrcode, 2)

        // let url = canvas.toDataURL('image/png')
        // $this.previewPoster = url
      }
    },
    write (ctx, obj, type, circle = false) { // 绘制其他元素
      ctx.fillStyle = 'rgb(' + obj.color.r + ',' + obj.color.g + ',' + obj.color.b + ')'
      if (type === 1) {
        ctx.font = obj.size + 'px Arial'
        ctx.fillText(this.preview.words, obj.x, obj.y)
      }
      if (type === 2) {
        if (circle) {
          let r = obj.w / 2
          ctx.beginPath()
          ctx.arc(obj.x - 0 + r, obj.y - 0 + r, r, 0, 2 * Math.PI)
          ctx.stroke()
          ctx.fill()
        } else {
          ctx.fillRect(obj.x, obj.y, obj.w, obj.h)
        }
      }
    },
    savePoster () {
      if (this.card && this.card !== '{}') {
        this.detail.card = JSON.stringify(this.card)
      }
      this.cardEdit()
    }
  },
  mounted () {
    let id = parseInt(this.$route.query.id)
    if (id) {
      this.detail.id = id
      this.getCardDetail()
    }
  },
  watch: {
    'preview.words': 'makePoster',

    'card.bg_url': 'makePoster',
    'card.name.x': 'makePoster',
    'card.name.y': 'makePoster',
    'card.name.w': 'makePoster',
    'card.name.h': 'makePoster',
    'card.name.color.r': 'makePoster',
    'card.name.color.g': 'makePoster',
    'card.name.color.b': 'makePoster',
    'card.name.size': 'makePoster',

    'card.balance.x': 'makePoster',
    'card.balance.y': 'makePoster',
    'card.balance.w': 'makePoster',
    'card.balance.h': 'makePoster',
    'card.balance.color.r': 'makePoster',
    'card.balance.color.g': 'makePoster',
    'card.balance.color.b': 'makePoster',
    'card.balance.size': 'makePoster',

    'card.unid.x': 'makePoster',
    'card.unid.y': 'makePoster',
    'card.unid.w': 'makePoster',
    'card.unid.h': 'makePoster',
    'card.unid.color.r': 'makePoster',
    'card.unid.color.g': 'makePoster',
    'card.unid.color.b': 'makePoster',
    'card.unid.size': 'makePoster',

    'card.app_name.x': 'makePoster',
    'card.app_name.y': 'makePoster',
    'card.app_name.w': 'makePoster',
    'card.app_name.h': 'makePoster',
    'card.app_name.color.r': 'makePoster',
    'card.app_name.color.g': 'makePoster',
    'card.app_name.color.b': 'makePoster',
    'card.app_name.size': 'makePoster',

    'card.headimg.x': 'makePoster',
    'card.headimg.y': 'makePoster',
    'card.headimg.w': 'makePoster',
    'card.headimg.h': 'makePoster',
    'card.headimg.color.r': 'makePoster',
    'card.headimg.color.g': 'makePoster',
    'card.headimg.color.b': 'makePoster',
    'card.headimg.size': 'makePoster',

    'card.qrcode.x': 'makePoster',
    'card.qrcode.y': 'makePoster',
    'card.qrcode.w': 'makePoster',
    'card.qrcode.h': 'makePoster',
    'card.qrcode.color.r': 'makePoster',
    'card.qrcode.color.g': 'makePoster',
    'card.qrcode.color.b': 'makePoster',
    'card.qrcode.size': 'makePoster'
  }
}
</script>



// WEBPACK FOOTER //
// src/page/function/card/cardEdit.vue